import { useAuth0 } from '@auth0/auth0-react'

export const useAuthService = () => {
  const auth = useAuth0()
  const login = (): Promise<void> => auth.loginWithRedirect()
  const logout = (): Promise<void> => auth.logout({ logoutParams: { returnTo: window.location.origin } })
  const isAuthenticated = auth.isAuthenticated
  const user = auth.user
  const isLoading = auth.isLoading
  return { login, logout, isAuthenticated, user, isLoading }
}
